import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import DashboardLayout from "@/components/DashboardLayout";
import Login from "@/pages/Login";
import RegisterQR from "@/pages/RegisterQR";
import CosignPage from "@/pages/CosignPage";
import ResetPassword from "@/pages/ResetPassword";
import Impressum from "@/pages/Impressum";
import Dashboard from "@/pages/Dashboard";
import Weblog from "@/pages/admin/Weblog";
import Users from "@/pages/admin/Users";
import Teilnehmer from "@/pages/admin/Teilnehmer";
import VerwaltungTeilnehmer from "@/pages/admin/VerwaltungTeilnehmer";
import DatenschutzVorlagen from "@/pages/admin/DatenschutzVorlagen";
import Anmeldeformulare from "@/pages/admin/Anmeldeformulare";
import CoursesList from "@/pages/courses/CoursesList";
import CourseView from "@/pages/courses/CourseView";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Wird geladen…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/anmelden/:token" element={<RegisterQR />} />
      <Route path="/mitanmelden/:token" element={<CosignPage />} />
      <Route path="/passwort-zuruecksetzen" element={<ResetPassword />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route
        element={
          <Protected>
            <DashboardLayout />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/kurse" element={<CoursesList />} />
        <Route path="/kurs/:id" element={<CourseView />} />
        <Route path="/weblog" element={<Weblog />} />
        <Route path="/benutzer" element={<Users />} />
        <Route path="/teilnehmer" element={<Teilnehmer />} />
        <Route path="/verwaltung/teilnehmer" element={<VerwaltungTeilnehmer />} />
        <Route path="/verwaltung/datenschutz" element={<DatenschutzVorlagen />} />
        <Route path="/verwaltung/formulare" element={<Anmeldeformulare />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
